import { METRICS_WITH_CURRENCY } from "@features/fundamentals/components/SecurityMetrics";

export const getCurrency = (metricKey?: string, currency?: string) =>
  metricKey && METRICS_WITH_CURRENCY.includes(metricKey) ? currency : undefined;
